import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

import { watch, nextTick } from 'vue';
import { TweenMax, Power1 } from 'gsap';


export default /*#__PURE__*/_defineComponent({
  __name: 'AnimatedMelatiText',
  props: {
  text: {
    type: String,
    required: true
  }
},
  emits: ['start', 'end'],
  setup(__props, { emit }) {

const props = __props;

const LETTER_ANIMATION_DURATION = 1;





watch(
  () => props.text,
  async newText => {
    const currentText = newText;
    emit('start');

    await nextTick();

    setTimeout(() => {
      // If the current selection is already deselected or another selection is made, cancel the tween.
      if (!props.text || currentText !== newText) {
        return;
      }

      TweenMax.to('.letter', {
        duration: LETTER_ANIMATION_DURATION,
        opacity: 1,
        ease: Power1.easeOut,
        stagger: {
          amount: 1
        },
        onComplete: () => emit('end')
      });
    }, 200);
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.text.split(/( )/), (word, i) => {
    return (_openBlock(), _createElementBlock("span", {
      key: word + i
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(word.split(''), (letter, i) => {
        return (_openBlock(), _createElementBlock("span", {
          class: "letter",
          key: letter + i
        }, _toDisplayString(letter === ' ' ? ' ' : letter), 1))
      }), 128))
    ]))
  }), 128))
}
}

})